import {BinaryWeek, DayOfWeekName, DaysOfWeek} from "../types/types";


export default function daysOfWeekToWorkweek(daysOfWeek:DaysOfWeek):BinaryWeek {

    const workweek : BinaryWeek = [
        daysOfWeek[DayOfWeekName.MON] ? 1 : 0,
        daysOfWeek[DayOfWeekName.TUE] ? 1 : 0,
        daysOfWeek[DayOfWeekName.WED] ? 1 : 0,
        daysOfWeek[DayOfWeekName.THU] ? 1 : 0,
        daysOfWeek[DayOfWeekName.FRI] ? 1 : 0,
        daysOfWeek[DayOfWeekName.SAT] ? 1 : 0,
        daysOfWeek[DayOfWeekName.SUN] ? 1 : 0,
    ]

    return workweek

}
